export default __webpack_public_path__ + "static/media/AAPG-Pivoting-8.dc096686.jpg";